import { render } from "./DefaultResult.vue?vue&type=template&id=05e82bf3&scoped=true"
import script from "./DefaultResult.vue?vue&type=script&lang=js"
export * from "./DefaultResult.vue?vue&type=script&lang=js"

import "./DefaultResult.vue?vue&type=style&index=0&id=05e82bf3&lang=scss&scoped=true"

import exportComponent from "/Users/andyhsieh/Desktop/tourist-site-project-master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05e82bf3"]])

export default __exports__